<script>
export default {
  name: 'Icon',
  functional: true,
  render(
    h,
    {
      props: { name },
      data
    }
  ) {
    return (
      <svg class="icon" {...data} aria-hidden="true" style="pointer-events: none">
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#${name}`} />
      </svg>
    )
  }
}
</script>
